import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="pricing-mode-form"
export default class extends Controller {
  static targets = ["mode", "flatFields", "tierFields"];

  connect() {
    this.toggle();
  }

  toggle() {
    const tiered = this.modeTarget.value === "quantity_tiered_per_result";
    const syncingProjectDefault = this.modeTarget.value === "inherit";
    this.flatFieldsTarget.classList.toggle("hidden", tiered || syncingProjectDefault);
    this.tierFieldsTarget.classList.toggle("hidden", !tiered);
    this.setFieldsDisabled(this.flatFieldsTarget, tiered || syncingProjectDefault);
    this.setFieldsDisabled(this.tierFieldsTarget, !tiered);
  }

  setFieldsDisabled(container, disabled) {
    if (container.tagName === "FIELDSET") container.disabled = disabled;
    container.querySelectorAll("input, select, textarea").forEach((field) => {
      field.disabled = disabled;
    });
  }
}
